import { useDispatch } from "react-redux";

import { useChartsContext } from "contexts/ChartContext";
import { BoxPlotDisplayMode } from "entities/charts/boxPlotDisplayMode";
import { updateChartByPath } from "store/features";

type BoxPlotMode = BoxPlotDisplayMode.Jitter | BoxPlotDisplayMode.Violin;

const ACTIVE_PATH: Record<BoxPlotMode, string> = {
  [BoxPlotDisplayMode.Jitter]: "features.jitterPlotToggle.active",
  [BoxPlotDisplayMode.Violin]: "features.violinPlotToggle.active"
};

/**
 * Shared toggle handler for the mutually exclusive jitter and violin box plot modes.
 *
 * Turning a mode on always clears the other so only one is ever active. Only jitter puts a field
 * on the x-axis, and it seeds that field itself (see JitterPlotToggle); the violin groups by the
 * global group by, like a plain box, and never writes an x-axis field.
 */
export function useBoxPlotModeToggle(mode: BoxPlotMode) {
  const dispatch = useDispatch();
  const { id } = useChartsContext();

  const otherMode: BoxPlotMode =
    mode === BoxPlotDisplayMode.Jitter
      ? BoxPlotDisplayMode.Violin
      : BoxPlotDisplayMode.Jitter;

  return (active: boolean) => {
    dispatch(
      updateChartByPath({
        id,
        path: ACTIVE_PATH[mode],
        value: active
      })
    );

    if (active) {
      dispatch(
        updateChartByPath({
          id,
          path: ACTIVE_PATH[otherMode],
          value: false
        })
      );
    }
  };
}
